import React, { FC, ReactNode } from "react";

import { Box, Typography } from "@components/base";
import ConfirmationModal from "@components/common/Modals/ConfirmationModal/ConfirmationModal";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: ReactNode;
  description?: ReactNode;
  details?: ReactNode;
  isLoading?: boolean;
  confirmDisabled?: boolean;
  cancelText?: string;
  confirmText?: string;
}

const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  details,
  isLoading,
  confirmDisabled,
  cancelText,
  confirmText,
}) => {
  const combinedDescription = (
    <Box>
      {description ? (
        <Typography component="div" variant="body1" color="textSecondary">
          {description}
        </Typography>
      ) : null}
      {details ? (
        <Typography
          component="div"
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1 }}
        >
          {details}
        </Typography>
      ) : null}
    </Box>
  );

  return (
    <ConfirmationModal
      open={open}
      title={title}
      description={combinedDescription}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      confirmDisabled={confirmDisabled}
      cancelText={cancelText}
      confirmText={confirmText}
    />
  );
};

export default DeleteConfirmationDialog;
